import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';

import { i18n } from '../attachmentsMacroi18n.ts';

export const EmptyState = (): React.JSX.Element => (
	<Box testId="attachments-empty-state" padding="space.300">
		<Text color="color.text.subtlest">
			<FormattedMessage {...i18n.noAttachments} />
		</Text>
	</Box>
);
